@let cell = cellSg();
@let type = typeSg();
@let rawValue = rawValueSg();
@let listValue = listValueSg();
@let enumType = enumSg();

@if (cell.componentRenderer; as renderer) {
  <atn-ds-table-cell-outlet
    [css]="cell.css"
    [renderer]="renderer"
  />
} @else if (type === IntrinsicEnum.Boolean) {
  <atn-value-boolean
    [style]="cell.css"
    [value]="!!cell.value"
  />
} @else if (listValue) {
  <atn-value-list
    [style]="cell.css"
    [value]="listValue"
  />
} @else if (enumType) {
  <atn-value-enum
    [color]="cell.css?.color"
    [enum]="enumType"
    [style]="cell.css"
    [value]="rawValue"
  />
} @else if (
  type === IntrinsicEnum.Currency ||
  type === IntrinsicEnum.Integer ||
  type === IntrinsicEnum.Percent
) {
  <atn-value-number
    [style]="cell.css"
    [value]="rawValue"
    [valueInfo]="cell.valueInfo"
  />
} @else {
  <atn-ds-value
    [style]="cell.css"
    [value]="rawValue"
    [valueInfo]="cell.valueInfo"
  />
}
